import {
  ChangeDetectionStrategy,
  Component,
  Injector,
  ViewEncapsulation,
} from '@angular/core';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AppInjector } from '@sc/data-access-app-injector';
import { ConfigurationService } from '@sc/data-access-configuration';
import { SandboxService } from '@sc/data-access-state-management';
import { AuthService } from '@sc/feature-auth-okta';
import { DialogService } from '@sc/feature-dialog';
import { FeatureToggleDirective } from '@sc/feature-flipping';
import { FocusManagerService } from '@sc/feature-focus-manager';
import { LoadingService, MainLoaderComponent } from '@sc/feature-loader';
import {
  HelpFabButtonComponent,
  ProductTourComponent,
} from '@sc/feature-product-tour';
import { TourService } from 'ngx-ui-tour-md-menu';

@Component({
  selector: 'sc-root-insurer',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MainLoaderComponent,
    RouterLink,
    RouterOutlet,
    TranslateModule,
    ProductTourComponent,
    HelpFabButtonComponent,
    FeatureToggleDirective,
  ],
  template: `
    <sc-main-loader></sc-main-loader>
    <a
      [routerLink]="[getRouterLink()]"
      queryParamsHandling="preserve"
      fragment="sc-container-id"
      (click)="onLinkClick('sc-container-id')"
      >{{
        'GlobalApplicativeConstants.accessibility.avoidanceLink' | translate
      }}</a
    >
    <router-outlet></router-outlet>
    <sc-product-tour
      *scFeatureToggle="'b2b-display-product-tour'"
    ></sc-product-tour>
    <ng-container>
      <sc-help-fab-button
        *scFeatureToggle="'b2b-display-product-tour'"
        (showTipsEvent)="showTips()"
      ></sc-help-fab-button>
    </ng-container>
  `,
})
export class AppComponent {
  showProductTourHelp = true;
  constructor(
    public injector: Injector,
    public configurationService: ConfigurationService,
    public sandboxService: SandboxService,
    public loadingService: LoadingService,
    public dialog: DialogService,
    private readonly tourService: TourService,
    private readonly authService: AuthService,
    private readonly route: Router,
    private readonly focusManager: FocusManagerService
  ) {
    AppInjector.setInjector(injector);

    this.authService.getAuthState$().subscribe((authState) => {
      if (authState.isAuthenticated) this.sandboxService.checkSubscription();
      this.sandboxService.setIsAuth(authState.isAuthenticated);
    });
  }

  showTips() {
    this.tourService.start();
  }

  getRouterLink() {
    const routeWithoutFragment = this.route.parseUrl(this.route.url);
    routeWithoutFragment.fragment = null;
    return routeWithoutFragment.toString();
  }

  onLinkClick(linkId: string) {
    this.focusManager.moveFocusStartingPoint(`#${linkId}`);
  }
}
